import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Loader from "rsuite/Loader";
import { groupBy } from "../../utility/common-methods";
import { fileDownloadMethod, httpGet } from "../../utility/requestHelper";
import { DownloadBlueIcon } from "../Icons/icons.component";
import * as XLSX from "xlsx";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import { ExportSheet } from "react-xlsx-sheet";
import {
  COOKIE,
  LANGUAGE_CODES,
  SOCIAL_SOURCES_OPTIONS,
} from "../../constants/app-constant";
import { setCookie } from "../../utility/cookieProvider";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function SocialDownload({
  articles,
  onSuccessCallback,
  downloadUrl,
  totalFeedCount,
  client_id,
  isSocial,
  IsBlogs,
  isLoading,
  setIsLoading,
  isDownloadAll = false,
  isTml = false,
  downloadList = []
}) {
  const [excelDataDetail, setexcelDataDetail] = useState([]);
  const [topicWiseData, setTopicWiseData] = useState([]);
  const [downloadArticles, setDownloadArticles] = useState([]);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const ref = useRef();
  // const head = [
  //   { title: "Entity", dataIndex: "topic_name" },
  //   { title: "Platform", dataIndex: "channel_type" },
  //   { title: "Tittle", dataIndex: "title" },
  //   { title: "Message", dataIndex: "message" },
  //   { title: "Tonality", dataIndex: "tonality" },
  //   { title: "Channel", dataIndex: "name" },
  //   { title: "User name / Author", dataIndex: "from_username" },
  //   { title: "Likes", dataIndex: "like_count" },
  //   { title: "Comments", dataIndex: "comment_count" },
  //   { title: "Shares", dataIndex: "share_count" },
  //   { title: "Views", dataIndex: "view_count" },
  //   { title: "Dislikes", dataIndex: "dislike_count" },
  //   { title: "Language", dataIndex: "language" },
  //   { title: "Source", dataIndex: "permalink" },
  //   { title: "Published Date", dataIndex: "created_at" },
  //   { title: "Tags", dataIndex: "tags" },
  // ];
  const head = [
    { title: "Entity", dataIndex: "topic_name" },
    { title: "Published Date", dataIndex: "publish_date" },
    { title: "Platform", dataIndex: "channel_type" },
    { title: "Tittle", dataIndex: "title" },
    { title: "Message", dataIndex: "message" },
    { title: "Tonality", dataIndex: "tonality" },
    { title: "Channel", dataIndex: "name" },
    { title: "User name / Author", dataIndex: "from_username" },
    { title: "Followers", dataIndex: "user_followers_count" }, 
    { title: "Channel", dataIndex: "name" },    
    { title: "Article URL", dataIndex: "articleurl" },
    { title: "Tittle", dataIndex: "title" },    
    { title: "Message", dataIndex: "message" },
    { title: "Language", dataIndex: "language" },
    { title: "Tonality", dataIndex: "tonality" },    
    { title: "Likes", dataIndex: "like_count" },
    { title: "Comments", dataIndex: "comment_count" },
    { title: "Shares", dataIndex: "share_count" },
    { title: "Views", dataIndex: "view_count" },
    { title: "Dislikes", dataIndex: "dislike_count" },
    { title: "Language", dataIndex: "language" },
    { title: "Source", dataIndex: "permalink" },
    { title: "Published Date", dataIndex: "created_at" },
    { title: "Dislikes", dataIndex: "dislike_count" },      
    { title: "Article ID", dataIndex: "id" },    
    { title: "Website URL", dataIndex: "permalink" },    
    { title: "Tags", dataIndex: "tags" },
    { title: "Published Date & Time", dataIndex: "created_at" },
  ];
  const platformName = (pName) => {
    const platformName = SOCIAL_SOURCES_OPTIONS.filter(
      (x) => x.value === pName
    )[0].label;
    return platformName || 'N/A';
  };
  const articleurl = (topic_name,id,channel_type,downloadUrl,client_id) => {    
    let articleurltxt = "https://clientportal.conceptbiu.com/mv/sad/"+client_id+"-"+channel_type+"/"+id+"?entityName=%22"+topic_name;
    let articleurltag = articleurltxt; //'<a href="'+articleurltxt+'">'+articleurltxt+'</a>';
    return articleurltag;
  };
  const getlanguagetext = (lang) => {    
    let langtxt = LANGUAGE_CODES[lang];
    if(langtxt == undefined || langtxt == '' || langtxt == null){
      langtxt = 'N/A';
    }
    return langtxt;
  };
  const checkvalues = (values) => {    
    let valuestxt = values;
    if(values == undefined || values == '' || values == null){
      valuestxt = 'N/A';
    }
    // console.log("checkvalues : ",valuestxt);
    return valuestxt;
  };

  const geturlforvalue = (values) => {    
    let valuestxt = values;
    if(values == undefined || values == '' || values == null){
      valuestxt = 'N/A';
    } else {
      valuestxt = valuestxt; //'<a href="'+valuestxt+'">'+valuestxt+'</a>';
    }
    return valuestxt;
  };

  const pundate = (values) => {    
    let valuestxt = values;
    if(valuestxt == undefined || valuestxt == '' || valuestxt == null){
      valuestxt = 'N/A';
    } else {
      valuestxt = moment(valuestxt).format("DD-MM-YYYY");
    }
    // console.log("pundate : ",valuestxt);
    return valuestxt;
  };

  const puntime = (values) => {    
    let valuestxt = values;
    if(valuestxt == undefined || valuestxt == '' || valuestxt == null){
      valuestxt = 'N/A';
    } else {
      valuestxt = moment(valuestxt).format("hh:mm a");
    }
    return valuestxt;
  };

  const pundatetime = (values) => {    
    let valuestxt = values;
    if(valuestxt == undefined || valuestxt == '' || valuestxt == null){
      valuestxt = 'N/A';
    } else {
      valuestxt = moment(valuestxt).format("DD-MM-YYYY h:mm:ss");
    }
    // console.log("pundatetime : ",valuestxt);
    return valuestxt;
  };

  const excelData = downloadArticles
    .map((feed) => {
      const {
        topic_name,
        channel_type,
        title,
        message,
        tonality,
        name,
        from_username,
        like_count,
        comment_count,
        share_count,
        view_count,
        dislike_count,
        lang,
        permalink,
        created_at,
        tags,
        id,
        user_followers_count
      } = feed;
      return {
        topic_name,
        publish_date:pundate(created_at),
        channel_type: platformName(channel_type),
        from_username,
        user_followers_count: checkvalues(user_followers_count),
        name: checkvalues(name),   
        articleurl: articleurl(topic_name,id,channel_type,downloadUrl,client_id),
        title: checkvalues(title),
        message,        
        language: getlanguagetext(lang),
        tonality: checkvalues(tonality),
        like_count,
        comment_count,
        share_count,
        view_count,
        dislike_count,
        id,
        permalink:geturlforvalue(permalink),
        tags: tags.map(({ tag_name }) => tag_name)[0],
        created_at:pundatetime(created_at),
      };
    })
    .flat();
  useEffect(() => {
    if (
      downloadArticles &&
      downloadArticles.length &&
      excelData &&
      excelData.length && 
      !isSocial
    ) {
      ref.current.click();
    }
  }, [downloadArticles]);

  const [tData,settData] = useState(null)
  useEffect(() => {
    const generateDownload = async () => {
      if(excelDataDetail.length && isSocial){
        let headerDetail = [
          
        ]
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Media Data');
        worksheet.columns = [
          { header:"Entity", key: 'topic_name'},
          { header:"Published Date", key:'publish_date'},
          { header:"Platform", key:'channel_type'},
          { header:"Author Name", key: 'author_name'},
          { header:"Author User name", key: 'author_user_name'},
          { header:"Author Followers", key: 'follower_count'},
          { header:"Author Following", key:"following"},
          { header:"Author Verified", key:'author_verified'},
          { header:"Channel", key:'name'},
          { header:"Article URL", key:'articleurl'},
          { header:"Title", key:'title'},
          { header:"Content Type", key:'content_type'},
          { header:"Message", key:'message'},
          { header:"Country", key:'country'},
          { header:"City", key:'city'},
          { header:"Language", key:'language'},
          { header:"Tonality", key:'tonality'},
          { header:"Engagement Score", key:'engagement_score'},
          { header:"Likes", key:'like_count'},
          { header:"Comments", key:'comment_count'},
          { header:"Shares", key:'share_count'},
          { header:"Views", key:'view_count'},
          { header:"Dislikes", key:'dislike_count'},
          { header:"Article ID", key:'id'},
          { header:"Website URL", key:'permalink'},
          { header:"Hashtags", key:'hastags'},
          { header:"Tags", key:'tags'},
          { header:"Published Date & Time", key:'p_date'},
        ];
        let i = 2
        excelDataDetail.forEach((eData) => {
          worksheet.addRow({...eData,...{
            publish_date:moment(eData.publish_date,"DD-MM-YYYY").format("DD MMM YYYY"),
            author_name: eData.channel_type !== "Youtube"?(eData.channel_type !== "LinkedIn"?((eData.profile?.profile_name)?eData.profile.profile_name:"N/A"):(eData.name?eData.name:"N/A")):(eData.name?eData.name:"N/A"),
            author_user_name:eData.channel_type !== "Facebook"?eData.from_username?eData.from_username:"N/A":((eData.profile?.username)?eData.profile.username:"N/A"),
            follower_count: (eData.profile?.follower_count)?eData.profile.follower_count:"N/A",
            following: (eData.profile?.following_count)?eData.profile.following_count:"N/A",
            author_verified: eData.profile?.is_verified == true?"Yes":"No",
            message: eData.message?.substring(0,32750),
            country: eData.country?eData.country:"N/A",
            city: eData.city?eData.city:"N/A",
            like_count: eData.like_count?eData.like_count:0,
            comment_count: eData.comment_count?eData.comment_count:0,
            share_count: eData.share_count?eData.share_count:0,
            view_count: eData.view_count?eData.view_count:0,
            dislike_count: eData.dislike_count?eData.dislike_count:0,
            hastags: eData.hastags?eData.hastags.map((data) => data.hashtag).join(","):"",
            tags: eData.tags?eData.tags:"",
            p_date: eData.publish_date+" - "+eData.publish_time
          }});
          worksheet.getCell('Y'+i).value = {
            text: 'Link',
            hyperlink: eData.permalink
          };
          worksheet.getCell('J'+i).value = {
            text: 'Link',
            hyperlink: eData.articleurl
          };
          ++i
        })
        worksheet.getColumn('engagement_score').numFmt = '0.00'; // Integer
        worksheet.getColumn('follower_count').numFmt = '0'; // Integer
        worksheet.getColumn('following').numFmt = '0'; // Integer
        worksheet.getColumn('like_count').numFmt = '0'; // Integer
        worksheet.getColumn('comment_count').numFmt = '0'; // Integer
        worksheet.getColumn('share_count').numFmt = '0'; // Integer
        worksheet.getColumn('view_count').numFmt = '0'; // Integer
        worksheet.getColumn('dislike_count').numFmt = '0'; // Integer
        worksheet.getColumn('id').numFmt = '@'; // Text (to preserve leading zeros)

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, `Media_${moment().format("DD_MM_YYYY")}.xlsx`);
      }
    }
    generateDownload()
  }, [excelDataDetail]);
  // useEffect(() => {
  //   if(excelDataDetail.length && isSocial){
  //     let headerDetail = [
  //       "Entity",
  //       "Published Date",
  //       // "Published Time",
  //       "Platform",
  //       "Author Name",
  //       "Author User name",
  //       "Author Followers",
  //       "Author Following",
  //       "Author Verified",
  //       "Channel",
  //       "Article URL",
  //       "Title",
  //       "Content Type",
  //       "Message",
  //       "Country",
  //       "City",
  //       "Language",
  //       "Tonality",
  //       "Engagement Score",
  //       "Likes",
  //       "Comments",
  //       "Shares",
  //       "Views",
  //       "Dislikes",
  //       "Article ID",
  //       "Website URL",
  //       "Hashtags",
  //       "Tags",
  //       "Published Date & Time",
  //     ]
  //     let tableData = document.createElement("table");
  //     const style = document.createElement("style")
  //     style.textContent = "table { font-size: 11pt; }"
  //     tableData.appendChild(style)
  //     let tbody = document.createElement("tbody");
  //     let tr = document.createElement("tr");
  //     tr.style.fontWeight="bold"
  //     tr.style.textAlign="center"
  //     tr.style.color="white"
  //     tr.style.backgroundColor="darkblue"
  //     headerDetail.forEach((hData) => {
  //       let td = document.createElement("td");
  //       td.append(hData)
  //       tr.append(td)
  //     })
  //     tbody.append(tr)
  //     // console.log(excelDataDetail,"line 264")
  //     excelDataDetail.forEach((eData) => {
  //       let ntr = document.createElement("tr");
  //       let ntd1 = document.createElement("td");
  //       ntd1.append(eData.topic_name)
  //       ntr.append(ntd1)
  //       let ntd2 = document.createElement("td");
  //       ntd2.append(moment(eData.publish_date,"DD-MM-YYYY").format("DD MMM YYYY"))
  //       ntr.append(ntd2)
  //       // let publishTime = document.createElement("td");
  //       // publishTime.append(eData.publish_time)
  //       // ntr.append(publishTime)
  //       let ntd3 = document.createElement("td");
  //       ntd3.append(eData.channel_type)
  //       ntr.append(ntd3)
  //       let ntd22 = document.createElement("td");
  //       ntd22.append(eData.channel_type !== "Youtube"?(eData.channel_type !== "LinkedIn"?((eData.profile?.profile_name)?eData.profile.profile_name:"N/A"):(eData.name?eData.name:"N/A")):(eData.name?eData.name:"N/A"))
  //       ntr.append(ntd22)
  //       let ntd4 = document.createElement("td");
  //       ntd4.append(eData.channel_type !== "Facebook"?eData.from_username?eData.from_username:"N/A":((eData.profile?.username)?eData.profile.username:"N/A"))
  //       ntr.append(ntd4)
  //       let ntd5 = document.createElement("td");
  //       ntd5.append((eData.profile?.follower_count)?eData.profile.follower_count:"N/A")
  //       ntd5.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd5)
  //       let ntd23 = document.createElement("td");
  //       ntd23.append((eData.profile?.following_count)?eData.profile.following_count:"N/A")
  //       ntd23.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd23)
  //       let ntd27 = document.createElement("td");
  //       ntd27.append(eData.profile?.is_verified == true?"Yes":"No")
  //       ntr.append(ntd27)
  //       let ntd6 = document.createElement("td");
  //       ntd6.append(eData.name)
  //       ntr.append(ntd6)
  //       let ntd7 = document.createElement("td");
  //       let articleA = document.createElement("a");
  //       articleA.append(eData.articleurl)
  //       articleA.href = eData.articleurl
  //       ntd7.append(articleA)
  //       ntr.append(ntd7)
  //       let ntd8 = document.createElement("td");
  //       ntd8.append(eData.title)
  //       ntr.append(ntd8)
  //       let ntd24 = document.createElement("td");
  //       ntd24.append(eData.content_type?eData.content_type:"")
  //       ntr.append(ntd24)
  //       let ntd9 = document.createElement("td");
  //       ntd9.append(eData.message?.substring(0,32750))
  //       ntr.append(ntd9)
  //       let ntd21 = document.createElement("td");
  //       ntd21.append(eData.country?eData.country:"N/A")
  //       ntr.append(ntd21)
  //       let ntd25 = document.createElement("td");
  //       ntd25.append(eData.city?eData.city:"N/A")
  //       ntr.append(ntd25)
  //       let ntd10 = document.createElement("td");
  //       ntd10.append(eData.language)
  //       ntr.append(ntd10)
  //       let ntd11 = document.createElement("td");
  //       ntd11.append(eData.tonality)
  //       ntr.append(ntd11)
  //       let ntd26 = document.createElement("td");
  //       ntd26.append(eData.engagement_score)
  //       ntr.append(ntd26)
  //       let ntd12 = document.createElement("td");
  //       ntd12.append(eData.like_count?eData.like_count:0)
  //       ntd12.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd12)
  //       let ntd13 = document.createElement("td");
  //       ntd13.append(eData.comment_count?eData.comment_count:0)
  //       ntd13.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd13)
  //       let ntd14 = document.createElement("td");
  //       ntd14.append(eData.share_count?eData.share_count:0)
  //       ntr.append(ntd14)
  //       let ntd15 = document.createElement("td");
  //       ntd15.append(eData.view_count?eData.view_count:0)
  //       ntd15.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd15)
  //       let ntd16 = document.createElement("td");
  //       ntd16.append(eData.dislike_count?eData.dislike_count:0)
  //       ntd16.setAttribute("data-excel-type", "number");
  //       ntr.append(ntd16)
  //       let ntd17 = document.createElement("td");
  //       ntd17.textContent = (eData.id)
  //       ntd17.setAttribute("data-excel-type", "text");
  //       ntr.append(ntd17)
  //       console.log(eData.id,"line 352")
  //       let ntd18 = document.createElement("td");
  //       let webA = document.createElement("a");
  //       webA.append(eData.permalink)
  //       webA.href = eData.permalink
  //       ntd18.append(webA)
  //       ntr.append(ntd18)
  //       let hashtags = document.createElement("td");
  //       // console.log(eData.hastags?eData.hastags.map((data) => data.hashtag).join(","):"","Hastags")
  //       hashtags.append(eData.hastags?eData.hastags.map((data) => data.hashtag).join(","):"")
  //       ntr.append(hashtags)
  //       let ntd19 = document.createElement("td");
  //       ntd19.append(eData.tags?eData.tags:"")
  //       ntr.append(ntd19)
  //       let ntd20 = document.createElement("td");
  //       ntd20.append(eData.publish_date+" - "+eData.publish_time)
  //       ntr.append(ntd20)
  //       tbody.append(ntr)
  //     })
  //     tableData.append(tbody)
  //     const wb = XLSX.utils.table_to_book(tableData);
  //     const ws = wb.Sheets[wb.SheetNames[0]];

  //     const rows = tableData.querySelectorAll("tr");
  //     // console.log(rows,"Line 375")
  //     for (let r = 1; r < rows.length; r++) {
  //       const cells = rows[r].querySelectorAll("td");
  //       for (let c = 0; c < cells.length; c++) {
  //         const cellAddress = XLSX.utils.encode_cell({ r, c });
  //         const cell = ws[cellAddress];
  //         const typeHint = cells[c].getAttribute("data-excel-type");
  //         // console.log(cell,typeHint)
  //         if (cell && typeHint) {
  //           if (typeHint === "text") {
  //             cell.t = "s";
  //             // cell.z = "@";
  //           } else if (typeHint === "number") {
  //             cell.t = "n";
  //             // cell.z = "0";
  //           }
  //           else{
  //             cell.t = "s";
  //           }
  //           // delete cell.w;
  //           XLSX.utils.format_cell(cell);
  //         }
  //       }
  //     }


  //     XLSX.writeFileXLSX(wb, "Media_"+moment().format("DD_MM_YYYY")+".xlsx");
  //     settData(tableData)
  //   }
  // }, [excelDataDetail]);

  useEffect(() => {
    try {
      if (articles) {
        const topicWiseGroupedFeeds = groupBy(articles, "topic_name");
        let filterWiseTopicData = [];
        Object.keys(topicWiseGroupedFeeds).forEach((topicData) => {
          const tFeeds = topicWiseGroupedFeeds[topicData];
          let tempObj = {
            downloadByFilter: [],
            doNotDownloadByFilter: [],
            topic_name: topicData,
            topic_id: tFeeds && tFeeds[0] && tFeeds[0].entityId,
          };
          tFeeds.forEach((feed) => {
            if (feed.isBulkUpdate) {
              tempObj.downloadByFilter.push(feed);
            } else {
              tempObj.doNotDownloadByFilter.push(feed);
            }
          });
          filterWiseTopicData.push(tempObj);
        });
        setTopicWiseData(filterWiseTopicData);
      }
    } catch (e) {}
  }, [articles]);

  const btnText = "Download Selected";

  const download = (downloadUrls, isDownloadAlls) => {
    // console.log('downloadUrls, isDownloadAlls', downloadUrls, isDownloadAlls)
    let allArticles = [];
    try {
      if (isSocial) {
        setCookie({
          key: COOKIE.IS_SOCIAL_DOWNLOADING,
          value: true,
        });
        setIsLoading(true);
        setDownloadArticles([]);
        const topicIdForUpdateByFilter = topicWiseData
          .map((twd) => {
            if (twd.downloadByFilter && twd.downloadByFilter.length) {
              return twd.topic_id;
            }
          })
          .filter(Boolean);
        let tempUrl = downloadUrls;
        tempUrl = tempUrl.replace("perPage=50", `perPage=${totalFeedCount}`);
        if (!isDownloadAlls) {
          tempUrl = tempUrl.slice(
            0,
            tempUrl.indexOf("&searchParams[topic_ids]")
          );
          if (topicIdForUpdateByFilter) {
            topicIdForUpdateByFilter.forEach((tId) => {
              tempUrl = `${tempUrl}&searchParams[topic_ids][]=${tId}`;
            });
          }
        }
        const selectedArticles = topicWiseData
          .map((twd) => {
            return twd.doNotDownloadByFilter.map((feed) => {
              const {
                topic_name,
                channel_type,
                title,
                message,
                tonality,
                name,
                from_username,
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                lang,
                permalink,
                created_at,
                tags,
                id,
                user_followers_count,
                country,
                reaction_metadata,
                platform,
                content_type,
                engagement_score,
                profile,
                city,
                hastags
              } = feed;

              return {
                topic_name,
                channel_type,
                title,
                message,
                tonality,
                name,
                from_username,
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                language: lang,
                permalink:geturlforvalue(permalink),
                created_at : moment(created_at).format("YYYY-MM-DD hh:mm a"),
                tags,
                id,
                user_followers_count,
                country,
                reaction_metadata,
                platform,
                content_type,
                engagement_score,
                profile,
                city,
                hastags
              };
            });
          })
          .flat();
        allArticles.push(...selectedArticles);
        if (
          isDownloadAlls ||
          (topicIdForUpdateByFilter && topicIdForUpdateByFilter.length)
        ) {
          httpGet(tempUrl)
            .then((res) => {
              setIsLoading(false);
              const { data } = res.data;
              setCookie({
                key: COOKIE.IS_SOCIAL_DOWNLOADING,
                value: null,
              });
              if (data && data.length) {
                // console.log('data', data)
                data.map(({ feeds, topic }) => {
                  if (feeds && feeds.length) {
                    const topicdata = feeds.map((singleFeed) => {
                      return { ...singleFeed, topic_name: topic.name };
                    });
                    allArticles.push(...topicdata);
                  }
                });
                setexcelDataDetail(allArticles
                  .map((feed) => {
                    // console.log("downloadArticles feed",feed);
                    const {
                      topic_name,
                      channel_type,
                      title,
                      message,
                      tonality,
                      name,
                      from_username,
                      like_count,
                      comment_count,
                      share_count,
                      view_count,
                      dislike_count,
                      lang,
                      permalink,
                      created_at,
                      tags,
                      id,
                      user_followers_count,
                      country,
                      reaction_metadata,
                      platform,
                      content_type,
                      engagement_score,
                      profile,
                      city,
                      hastags
                    } = feed;
                    // console.log("##### feed",feed,lang);
                    return {
                      topic_name,
                      publish_date:pundate(created_at),
                      publish_time:puntime(created_at),
                      channel_type: platformName(channel_type),
                      from_username,
                      user_followers_count: checkvalues(user_followers_count),
                      name: checkvalues(name),   
                      articleurl: articleurl(topic_name,id,channel_type,downloadUrl,client_id),
                      title: checkvalues(title),
                      message,        
                      language: getlanguagetext(lang),
                      tonality: checkvalues(tonality),    
                      like_count,
                      comment_count,
                      share_count,
                      view_count,
                      dislike_count,
                      id,
                      country,
                      permalink:geturlforvalue(permalink),        
                      tags: tags.map(({ tag_name }) => tag_name)[0],
                      created_at:pundatetime(created_at),
                      reaction_metadata,
                      platform,
                      content_type,
                      engagement_score,
                      profile,
                      city,
                      hastags
                    };
                  })
                  .flat())  
                setDownloadArticles(allArticles);
              }
              setCookie({
                key: COOKIE.DOWNLOAD_SUCCESS,
                value: true,
              });
              setIsLoading(false);
              onSuccessCallback();
            })
            .catch(() => {
              setCookie({
                key: COOKIE.IS_SOCIAL_DOWNLOADING,
                value: null,
              });
              setIsLoading(false);
            });
        } else {
          setexcelDataDetail(allArticles
            .map((feed) => {
              const {
                topic_name,
                channel_type,
                title,
                message,
                tonality,
                name,
                from_username,
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                language,
                permalink,
                created_at,
                tags,
                id,
                user_followers_count,
                country,
                reaction_metadata,
                platform,
                content_type,
                engagement_score,
                profile,
                city,
                hastags
              } = feed;
              return {
                topic_name,
                publish_date:pundate(created_at),
                publish_time:puntime(created_at),
                channel_type: platformName(channel_type),
                from_username,
                user_followers_count: checkvalues(user_followers_count),
                name: checkvalues(name),   
                articleurl: articleurl(topic_name,id,channel_type,downloadUrl,client_id),
                title: checkvalues(title),
                message,        
                language: getlanguagetext(language),
                tonality: checkvalues(tonality),    
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                id,
                country,
                permalink:geturlforvalue(permalink),        
                tags: tags.map(({ tag_name }) => tag_name)[0],
                created_at:pundatetime(created_at),
                reaction_metadata,
                platform,
                content_type,
                engagement_score,
                profile,
                city,
                hastags
              };
            })
            .flat())
          setDownloadArticles(allArticles);
          setIsLoading(false);
          setCookie({
            key: COOKIE.IS_SOCIAL_DOWNLOADING,
            value: null,
          });
        }
      }
      if (IsBlogs) {
        setCookie({
          key: COOKIE.IS_BLOG_DOWNLOADING,
          value: true,
        });
        setIsLoading(true);
        setDownloadArticles([]);
        const topicIdForUpdateByFilter = topicWiseData
          .map((twd) => {
            if (twd.downloadByFilter && twd.downloadByFilter.length) {
              return twd.topic_id;
            }
          })
          .filter(Boolean);
        let tempUrl = downloadUrl;
        tempUrl = tempUrl.replace("perPage=50", `perPage=${totalFeedCount}`);
        tempUrl = tempUrl.slice(0, tempUrl.indexOf("&searchParams[topic_ids]"));
        tempUrl = `${tempUrl}&searchParams[channel_type][]=${5}&searchParams[channel_type][]=${6}`;
        tempUrl = `${tempUrl}&searchParams[type][]=${5}&searchParams[type][]=${6}`;
        if (topicIdForUpdateByFilter) {
          topicIdForUpdateByFilter.forEach((tId) => {
            tempUrl = `${tempUrl}&searchParams[topic_ids][]=${tId}`;
          });
        }
        const selectedArticles = topicWiseData
          .map((twd) => {
            return twd.doNotDownloadByFilter.map((feed) => {
              const {
                topic_name,
                channel_type,
                title,
                message,
                tonality,
                name,
                from_username,
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                lang,
                permalink,
                created_at,
                tags,
              } = feed;

              return {
                topic_name,
                channel_type,
                title,
                message,
                tonality,
                name,
                from_username,
                like_count,
                comment_count,
                share_count,
                view_count,
                dislike_count,
                language: lang,
                permalink,
                created_at,
                tags,
              };
            });
          })
          .flat();
        allArticles.push(...selectedArticles);
        if (topicIdForUpdateByFilter && topicIdForUpdateByFilter.length) {
          httpGet(tempUrl)
            .then((res) => {
              setCookie({
                key: COOKIE.IS_BLOG_DOWNLOADING,
                value: null,
              });
              setIsLoading(false);
              const { data } = res.data;
              if (data && data.length) {
                data.map(({ feeds, topic }) => {
                  if (feeds && feeds.length) {
                    const topicdata = feeds.map((singleFeed) => {
                      return { ...singleFeed, topic_name: topic.name };
                    });
                    allArticles.push(...topicdata);
                  }
                });
                setDownloadArticles(allArticles);
              }
              setIsLoading(false);
              setCookie({
                key: COOKIE.DOWNLOAD_SUCCESS,
                value: true,
              });
              onSuccessCallback();
            })
            .catch(() => {
              setCookie({
                key: COOKIE.IS_BLOG_DOWNLOADING,
                value: null,
              });
              setIsLoading(false);
            });
        } else {
          setDownloadArticles(allArticles);
          setIsLoading(false);
          setCookie({
            key: COOKIE.IS_BLOG_DOWNLOADING,
            value: null,
          });
        }
      }
    } catch (e) {
      setIsLoading(false);
      console.error("[Error]: Cannot download file", e);
      return;
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
        {!isSocial?
          <ExportSheet
            header={head}
            dataSource={excelData}
            xlsx={XLSX}
            fileName={`Media`}
          >
            <span ref={ref}></span>
          </ExportSheet>
          :<ExportSheet
              dataType="Table-Node-Element"
              fileName={`table`}
              tableElement={tData}
              xlsx={XLSX}
              isDOMElement={true}
            > 
              <span ref={ref}></span>
            </ExportSheet>}
           {IsBlogs ? (
          <button
            className="dropdown-toggle btn btn-default"
            onClick={() => download()}
            disabled={(!articles || !articles.length) && !isDownloadAll}
          >
            <DownloadBlueIcon />
            <span>{isTml ? "DownLoad TML Channel" : isDownloadAll ? "Download All" : btnText}</span>
          </button>
          ) : (


          <Dropdown alignRight>
          <Dropdown.Toggle variant="default">
            <DownloadBlueIcon />
            <span >
              Download
            </span>
          </Dropdown.Toggle>
          {<Dropdown.Menu>
            {downloadList.map((item, index) => item.label && (
              <>
             
          <Dropdown.Item key={index} onClick={(e) => download(item.downloadUrl, item.isDownloadAll)}>
              {item.label}
            </Dropdown.Item>
              </>
            
          ))}
            </Dropdown.Menu>}
        </Dropdown>
          )}
        </>
      )}
    </>
  );
}

SocialDownload.defaultProps = {
  articles: [],
  onSuccessCallback: () => {},
};
export default SocialDownload;
